module.exports = __webpack_public_path__ + "img/brand_logo.af4ba37.png";